import RemovalQuotaModal from "./RemovalQuotaModal";

export default RemovalQuotaModal;
